'use client';
import type { ReactElement } from 'react';
import { GraphToolbarButton } from '../Cmarkdowngraphcontrols';
const SVG_STROKE_VALUE = {
    CurrentColor: 'currentColor',
    Round: 'round',
} as const;
const FLOWCHART_BUTTON_ICON = 'flowchartToolbarButtonIcon';
const FLOWCHART_TOOLBAR_PATH = 'flowchartToolbarButtonPath';
const FLOWCHART_TOP_LEFT_CORNER_PATH_ID = 'top-left';
const FLOWCHART_TOP_RIGHT_CORNER_PATH_ID = 'top-right';
const FLOWCHART_BOTTOM_LEFT_CORNER_PATH_ID = 'bottom-left';
const FLOWCHART_BOTTOM_RIGHT_CORNER_PATH_ID = 'bottom-right';
const FLOWCHART_LEFT_RAIL_PATH_ID = 'left-rail';
const FLOWCHART_CENTER_RAIL_PATH_ID = 'center-rail';
interface FlowchartToolbarButtonsProps {
    canFocusFlowchart: boolean;
    isMinimapVisible: boolean;
    onFocusFlowchart: () => void;
    onToggleMinimap: () => void;
}
export function FlowchartToolbarButtons({ canFocusFlowchart, isMinimapVisible, onFocusFlowchart, onToggleMinimap, }: FlowchartToolbarButtonsProps): ReactElement {
    return (<>
      <GraphToolbarButton onClick={onFocusFlowchart} disabled={!canFocusFlowchart} label="Focus chart">
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M5 1.5H1.5V5" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M9 1.5H12.5V5" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M5 12.5H1.5V9" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M9 12.5H12.5V9" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.2} strokeLinecap={SVG_STROKE_VALUE.Round} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
        </svg>
      </GraphToolbarButton>
      <GraphToolbarButton onClick={onToggleMinimap} disabled={false} label={isMinimapVisible ? 'Hide minimap' : 'Show minimap'}>
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden>
          <path d="M1.5 3.2L4.8 1.8L9.2 3.2L12.5 1.8V10.8L9.2 12.2L4.8 10.8L1.5 12.2V3.2Z" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.1} strokeLinejoin={SVG_STROKE_VALUE.Round}/>
          <path d="M4.8 1.8V10.8" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.1}/>
          <path d="M9.2 3.2V12.2" stroke={SVG_STROKE_VALUE.CurrentColor} strokeWidth={1.1}/>
        </svg>
      </GraphToolbarButton>
    </>);
}
